package top.wcpe.allincore.ui.runtime.ir

/**
 * DSL 运行时异常。
 *
 * 由解释器在表达式/语句求值阶段抛出，用于：
 * - 类型错误（例如算术操作两侧不可数值化）
 * - 访问未声明的 state / 局部变量
 * - 不支持的运算或操作
 *
 * 仅本异常类型可被 DSL 的 `try/catch` 捕获；JVM 自身异常会被 wrap 成本类型再向上传递。
 *
 * 继承 [IllegalStateException]：现有解释器既有的 throw 点采用的就是
 * `IllegalStateException`，统一把这些路径升格为 `DslRuntimeError`，
 * 既保持向后兼容（旧测试期望 ISE 仍然成立），又能被 DSL 的 catch 捕获。
 */
open class DslRuntimeError(message: String, val line: Int = 0, val column: Int = 0, cause: Throwable? = null) :
    IllegalStateException(message, cause) {
    constructor(message: String) : this(message, 0, 0, null)
    constructor(message: String, line: Int, column: Int) : this(message, line, column, null)
    constructor(message: String, cause: Throwable) : this(message, 0, 0, cause)
}
